import { Modal } from '../../../application/application/modal'
import { selectProductOption } from './select-product-option'

export function createCompareModal(root) {
  const template = document.getElementById('product-view-compare-modal')
  if (template) {
    return new Modal({
      heading: 'Console Quick Compare',
      template: template,
      additionalClasses: ['compare-modal'],
      created(modal) {
        modal.modalEl.querySelectorAll('[data-option-id]').forEach((item) => {
          item.addEventListener('click', () => {
            selectProductOption(root, item.dataset.optionId, modal)
            modal.close()
          })
        })
      }
    })
  }
  return false
}
